import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { ErrorCode } from 'app/shared/models/error.models';

export const DistanceResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
  const router: Router = inject(Router);
  const distance: string | null = route.paramMap.get('distance');
  const distanceNumber: number = Number(distance);

  if (!distance || isNaN(distanceNumber) || distanceNumber > Number.MAX_SAFE_INTEGER)
    return new RedirectCommand(router.parseUrl(`/error/${ErrorCode.INVALID_GOAL}`));
  return distance;
};
